'use_strict';

(function defSideBar(global) {

  // Константы
  const tabSelector = 'div.tab_item';
  const moreTabName = 'More';
  const moreTabSelector = '.more';

  /**
   * Класс-обертка для панели закладок
   * @class WebAccess.components.wrappers.sideBar.SideBar
   * @since 5.2.0.1600
   */
  const SideBar = BaseObject.extend({

      /**
       * @inheritDoc
       * @param {string} containerSelector Селектор контейнера сайдбара.
       * @param {object} current Текущий объект системы.
       */
      init(containerSelector, current) {
        this._jSideBar = $(containerSelector);
        this._jAfterTabs = this._jSideBar.find(".after_tabs");
        this._super();

        // Не появляется горизонтальный скроллинг в детальном разделе, пока не
        // пошевелишь колонки
        // #106665
        // Это может быть медленно, особенно где много вкладок и таблиц
        this.bind(this['class'].EVENT.AFTER_TAB_SWITCH, () => {
          _(current._getGrids()).each((grid) => {
            setTimeout(() => {
              grid.grid.resizeCanvas();

              // #106257 Поле в детальном разделе не становится активным. Помогает обновление страницы
              grid.grid.resetActiveCell();
            }, 0);
          });
        });

        // Сворачивает вкладки в "Еще" при изменении размеров экрана.
        $(window).bind('resizeEnd', () => {
          this.resizeHorizontalTabs();
        });        
      },

      /**
      * Cворачивание / разорачивание горизонтальных закладок в кнопку еще.
      *
      * @method WebAccess.components.wrappers.sideBar.SideBar#resizeHorizontalTabs      
      * @return {WebAccess.current.sideBar} Текущий сайдбар.
      * @since 5.7.0
      */
      resizeHorizontalTabs() {
        this._jAfterTabs.addClass("hidden");
        this._fitHorizontalTabs();
      },


      /**
       * Логика сворачивания / разорачивания горизонтальных закладок в кнопку еще.
       *
       * @method WebAccess.components.wrappers.sideBar.SideBar#_fitHorizontalTabs
       * @private
       * @return {WebAccess.current.sideBar} Текущий сайдбар.
       * @since 5.2.0.1600
       */
      _fitHorizontalTabs() {
        return this._fitTabs('outerWidth', this._jSideBar.width());
      },

      /**
       * Логика сворачивания / разорачивания вертикальных закладок в кнопку Еще.
       *
       * @deprecated since 5.6.
       * @method WebAccess.components.wrappers.sideBar.SideBar#_fitVerticalTabs
       * @private
       * @return {WebAccess.current.sideBar} Текущий сайдбар.
       * @since 5.2.0.1600
       */
      _fitVerticalTabs() {
        this._warnAboutDeprecatedMethod(arguments.callee.name);
        return this;
      },

      /**
       * Подсчет ширины или высоты всех закладок.
       *
       * @method WebAccess.components.wrappers.sideBar.SideBar#_getSideBarSize
       * @private
       * @return {number} Ширина сайдбара в пикселах.
       * @since 5.2.0.1600
       */
      _getSideBarSize() {
        let sideBarSize = 0;

        this._jSideBar.find(`${tabSelector}:visible`).each(function () {
          sideBarSize += $(this).outerWidth();
        });

        return sideBarSize;
      },

      /**
       * Получение ширины или высоты последней нескрытой закладки (не учитывая закладку "Еще").
       *
       * @method WebAccess.components.wrappers.sideBar.SideBar#_getLastTabSize
       * @param {object} jSideBar - контейнер сайдбара
       * @param {string} sizeName - измерение (доступные значения: 'outerWidth', 'outerHeight').
       * @private
       * @return {integer} Ширина последней вкладки в пикселах.
       * @since 5.2.0.1600
       */
      _getLastTabSize(sizeName) {
        let jTabs = this._jSideBar.find('span:first').find(tabSelector);
        return $.fn[sizeName].call(jTabs.not(moreTabSelector).last(), true);
      },

      /**
       * Логика сворачивания / разворачивания закладок в кнопку "Еще".
       *
       * @method WebAccess.components.wrappers.sideBar.SideBar#_fitTabs
       * @param {string} sizeName - измерение (доступные значения: 'outerWidth', 'outerHeight').
       * @param {number} availableSize - доступная максимальная величина измерения.
       * @private
       * @return {WebAccess.current.sideBar} Текущий сайдбар.
       * @since 5.2.0.1600
       */
      _fitTabs(sizeName, availableSize) {
        // Скрыть сайдбар
        this._jSideBar.css('display', 'hidden');

        // Развернуть сайдбар полностью
        while (this.expand()) ;

        // Свернуть группы, если необходимо
        while (availableSize < this._getSideBarSize() && this.collapse()) ;

        // Отобразить сайдбар
        this._jSideBar.css('display', 'block');

        return this;
      },

      /**
       * Восстановить спрятанные закладки
       * Спрятать кнопку "Еще".
       *
       * @method WebAccess.components.wrappers.sideBar.SideBar#_internalExpand
       * @private
       * @return {boolean} имеется ли возможность дальнейшего разворачивания
       * @since 5.2.0.1600
       */
      _internalExpand(jSideBar) {
        let collapsedTabs = this._jAfterTabs.find(tabSelector);
        let firstCollapsedTab = collapsedTabs.first();
        let prevId = firstCollapsedTab.data('prevId');

        if (prevId) {
          this._jSideBar
            .find(`#${prevId}`)
            .after(firstCollapsedTab);
        } else {
          this._jSideBar
            .find(`${tabSelector}:first`)
            .before(firstCollapsedTab);
        }

        if (collapsedTabs.length === 1) {
          this._internalExpand();
        }

        let jFirstTab = this._jAfterTabs.find(`${tabSelector}:first`);
        if (!jFirstTab.length) {
          if (!!this.tabs[moreTabName]) {
            this.tabs[moreTabName]._jObject.remove();
            delete this.tabs[moreTabName];
          }
          return false;
        }
        return true;
      },

      /**
       * Показать кнопку "Еще".
       * Спрятать все, что не влазит в неё.
       * Создать выпадющее меню по аналогии с группами.
       *
       * @method WebAccess.components.wrappers.sideBar.SideBar#_internalCollapse
       * @private
       * @return {boolean} имеется ли возможность дальнейшего сворачивания
       * @since 5.2.0.1600
       */
      _internalCollapse() {
        // Если нет вкладки "Ещё", то добавим ее
        if (!this.tabs[moreTabName]) {
          let moreTab = this.tabs.create({
            name: moreTabName,
            label: L('MORE_TABS'),
            toolTip: L('OTHER_TABS'),
          });
          moreTab.click(() => {
          });

          // Установим событие нажатия на вкладку
          moreTab._jObject.click((event) => {
            event.stopPropagation();
            this._jAfterTabs.toggleClass("hidden");

            let collapsedTabsLeftOffset = moreTab._jObject.offset().left;
            let collapsedTabsWidth = this._jAfterTabs.width();

            if (collapsedTabsLeftOffset + collapsedTabsWidth > windowWidth()) {
              collapsedTabsLeftOffset = windowWidth() - collapsedTabsWidth - 10;
            }

            this._jAfterTabs.css({
              left: collapsedTabsLeftOffset,
            });
            $('.CardForm').redraw(); //#106605
          });
        } else {
          this.tabs[moreTabName].show();
        }

        let jMore = this._jSideBar
          .find(this.tabs[moreTabName].selector)
          .addClass('more');

        let lastTab = jMore.prev(tabSelector);
        if (!lastTab.length) {
          return false;
        }

        if (lastTab.hasClass('selected')) {
          lastTab = lastTab.prev(tabSelector);
          if (!lastTab.length) {
            return false;
          }
        }

        lastTab.data('prevId', lastTab.prev().attr('id'));
        this._jAfterTabs.prepend(lastTab);

        return true;
      },

      /**
       * Развернуть содержимое закладок или дерево задач в проводнике.
       * В карточках объектов пошагово переносит скрытые закладки с закладки «Еще» на боковую панель.
       *
       * @method WebAccess.components.wrappers.sideBar.SideBar#expand
       */
      expand() {
        return this._internalExpand();
      },

      /**
       * Свернуть содержимое закладок или дерево папок в проводнике.
       * В карточках объектов пошагово переносит закладки с боковой панели на закладку «Еще».
       *
       * @method WebAccess.components.wrappers.sideBar.SideBar#collapse
       * @return {WebAccess.current.sideBar | boolean} True – имеется возможность свернуть содержимое закладок, иначе False.
       */
      collapse() {
        return this._internalCollapse();
      },

      /**
       * Проверить, свернута ли боковая панель.
       *
       * @method WebAccess.components.wrappers.sideBar.SideBar#isCollapsed
       * @since 5.2.0.1600
       */
      isCollapsed() {
        return !!this.tabs[moreTabName];
      },

      /**
       * Изменить расположение боковой панели.
       *
       * @deprecated since 5.6.
       * @method WebAccess.components.wrappers.sideBar.SideBar#setOrientation
       * @param {ORIENTATION} orientation Режим расположения боковой панели.
       * Возможные значения:HORIZONTAL – горизонтальное; VERTICAL – вертикальное.
       * @since 5.2.0.1600
       */
      setOrientation(orientation) {
        this._warnAboutDeprecatedMethod(arguments.callee.name);
        return this;
      },

      /**
       * Проверить, вертикально ли распологается боковая панель.
       *
       * @deprecated since 5.6.
       * @method WebAccess.components.wrappers.sideBar.SideBar#isVertical
       * @return {boolean} True – боковая панель располагается вертикально, иначе False.
       * @since 5.0.0.4206
       */
      isVertical() {
        this._warnAboutDeprecatedMethod(arguments.callee.name);
        return false;
      },

      /**
       * Установить первоначальное положение закладок боковой панели.
       *
       * @deprecated since 5.6.
       * @method WebAccess.components.wrappers.sideBar.SideBar#moveSidebarToLeftColumn
       * @since 5.2.0.1600
       */
      moveSidebarToLeftColumn() {
        this._warnAboutDeprecatedMethod(arguments.callee.name);
        return this;
      }
    }, {
      EVENT: {
        /**
         * Срабатывает до смены закладки
         * @event WebAccess.components.wrappers.sideBar.SideBar.EVENT.BEFORE_TAB_SWITCH
         * @param {WebAccess.components.wrappers.sideBar.Tab} закладка,
         * на которую произошло переключение
         * @since 5.2.0.1304
         */
        BEFORE_TAB_SWITCH: 'beforeTabSwitch',
        //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

        /**
         * Срабатывает после смены закладки
         * @event WebAccess.components.wrappers.sideBar.SideBar.EVENT.AFTER_TAB_SWITCH
         * @param {WebAccess.components.wrappers.sideBar.Tab} закладка,
         * на которую произошло переключение
         * @since 5.2.0.1304
         */
        AFTER_TAB_SWITCH: 'afterTabSwitch'
        //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
      }
    }
  );

  WA.CMP.wrappers.sideBar.SideBar = SideBar;

})(window.WA);
